module.exports = __webpack_public_path__ + "static/media/862f9cc8.jpg";